import { Box, Typography } from "@mui/material";
import {
  blackColor,
  lightGrayColor,
  lightVioletColor,
  whiteColor,
} from "../constants/colors";

const Switcher = ({ value, onChange }) => {
  return (
    <Box
      sx={{
        width: "71px",
        height: "31px",
        borderWidth: "1px",
        borderStyle: "solid",
        borderColor: blackColor,
        cursor: "pointer",
        display: "flex",
      }}
      onClick={() => onChange(!value)}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          backgroundColor: value ? lightVioletColor : whiteColor,
          flex: value ? 1.1 : 0.9,
          borderRightWidth: value ? "1px" : "0px",
          borderRightStyle: "solid",
          borderRightColor: blackColor,
        }}
      >
        {!value && (
          <Typography
            sx={{ fontSize: "12px", color: blackColor, fontWeight: "500" }}
          >
            OFF
          </Typography>
        )}
      </Box>
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          backgroundColor: !value ? lightGrayColor : whiteColor,
          flex: !value ? 1.1 : 0.9,
          borderLeftWidth: !value ? "1px" : "0px",
          borderLeftStyle: "solid",
          borderLeftColor: blackColor,
        }}
      >
        {value && (
          <Typography
            sx={{ fontSize: "12px", color: blackColor, fontWeight: "500" }}
          >
            ON
          </Typography>
        )}
      </Box>
    </Box>
  );
};

export default Switcher;
